import axios from 'axios';

export const actionTypes = (typeName, prefix = null) => {
  const name = prefix ? prefix + '_' + typeName : typeName;
  return {
    [typeName]: {
      START: `${name}_START`,
      SUCCESS: `${name}_SUCCESS`,
      ERROR: `${name}_ERROR`,
    },
  };
};

export const instance = axios.create({
  baseURL: `${window.location.origin}/${process.env.REACT_APP_FLOWABLE_CONTEXT_PATH}`,
  withCredentials: true,
});

export const getQueryString = data => {
  return Object.entries(data)
    .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
    .join('&');
}